import { takeEvery, call, put, select } from 'redux-saga/effects';
import { createReducerName } from 'mt-react-common/modules/messenger/reducers/dynamic/roomMessages/combineRegistry';
import { t } from 'utils/translates';

import {
  sendFrom,
  requestInProcess,
  requestFinished,
  setErrors,
  selectFormBody,
  clearAllErrors,
  initState,
  recoveryFormFields,
  requestRecoveryForm
} from '../createGroupRoomForm';

import {
  addItemsToUp,
  sendRequest as refreshList
} from '../../../../../../../common/reducers/list/reducer';

import { dataRequest as refreshRoom } from '../../../../../../../common/reducers/objectCollection/reducer';

import { timeoutCall } from '../../../../../../../utils/sagaHalper';
import MessengerService from '../../../../../services/MessengerService';
import * as clientNoticesActions from '../../../../../../main/reducers/static/states/clientNotices/reducer';

const combineName = roomUuid => createReducerName(`room-${roomUuid}`);
const roomMessagesListRN = roomUuid => `${combineName(roomUuid)}.list`;

function* requestRecoveryFormSaga(reducerName, action) {
  try {
    yield put(clearAllErrors(reducerName));
    const result = yield call(
      timeoutCall,
      MessengerService.getUserRoomByUuid,
      action.payload
    );
    if (result.response.status === 200) {
      yield put(
        recoveryFormFields(
          reducerName,
          result.destructData.itemsById[action.payload]
        )
      );
    }
    requestFinished(reducerName, result.status, result.status === 200);
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName));
}

function* sendFormSaga(reducerName, action) {
  const formBody = yield select(selectFormBody, reducerName);
  yield put(requestInProcess(reducerName));
  try {
    yield put(clearAllErrors(reducerName));

    let result = null;
    if (action.payload) {
      result = yield call(
        timeoutCall,
        MessengerService.editRoom,
        action.payload,
        formBody
      );
      if (result.response) {
        if (result.response.status === 422) {
          yield put(setErrors(reducerName, result.response.data));
        } else if (result.response.status === 200) {
          yield put(initState(reducerName));
          yield put(
            refreshRoom(
              'messengerModule.collections.userRoomsCollection',
              action.payload
            )
          );
          console.log(result);
          yield put(
            addItemsToUp(
              roomMessagesListRN(action.payload),
              result.destructData.itemsIds,
              result.destructData.itemsById
            )
          );
          yield put(
            clientNoticesActions.addClientNotice({
              type: 'success',
              message: t('Группа успешно изменена')
            })
          );
        }
      }
    } else {
      result = yield call(timeoutCall, MessengerService.createRoom, formBody);
      if (result) {
        if (result.response.status === 422) {
          yield put(setErrors(reducerName, result.response.data));
        } else if (result.response.status === 201) {
          yield put(initState(reducerName));
          yield put(refreshList('messengerModule.lists.messengerMyRoomsList'));
          yield put(
            clientNoticesActions.addClientNotice({
              type: 'success',
              message: t('Группа успешно создана')
            })
          );
        }
      }
    }
    yield put(
      requestFinished(
        reducerName,
        result.response.status,
        [200, 201].includes(result.response.status)
      )
    );
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
  yield put(requestFinished(reducerName));
}

export default function getSaga(reducerName) {
  return [
    takeEvery(sendFrom(reducerName).type, sendFormSaga, reducerName),
    takeEvery(
      requestRecoveryForm(reducerName).type,
      requestRecoveryFormSaga,
      reducerName
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/messenger/reducers/static/forms/createGroupRoom/sagas/createGroupRoomFormSaga.js